import {
  Grid, Paper, Tab, Tabs, Typography, Box, Container, useTheme,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React, { useState } from 'react';
// import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import ResponsiveContainer from '../components/ResponsiveContainer';
import AccessStory from '../components/AccessStory';
import AffordabilityStory from '../components/AffordabilityStory';
import LeadStory from '../components/LeadStory';
import CovidStory from '../components/CovidStory';
import StateMap from '../components/StateMap';
import states from '../modules/states';
import colors from '../modules/colors';
import { years } from '../modules/years';

export default function StateDashboard() {
  const theme = useTheme();
  const stories = ['affordability', 'access', 'leadexposure', 'covid-19'];
  const { stateCode, story } = useParams();
  const [selectedTab, setSelectedTab] = useState(stories.indexOf(story) !== -1 ? stories.indexOf(story) : 0);

  // set up background colors for each story
  const storyColors = [colors.green, colors.purple, colors.yellow, colors.coral];

  const classes = makeStyles((t) => ({
    card: {
      margin: '0px 5px 5px 5px',
    },
    wrapIcon: {
      verticalAlign: 'middle',
      display: 'inline-flex',
    },
    section: {
      marginTop: t.spacing(6),
    },
    paper: {
      padding: t.spacing(2),
    },
    maxContentWidth: {
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '1200px',
      paddingLeft: t.spacing(2),
      paddingRight: t.spacing(2),
      width: '100%',
    },
    stateHeader: {
      paddingTop: t.spacing(2),
      paddingBottom: t.spacing(2),
      backgroundColor: '#3e4044 !important',
    },
    stateName: {
      color: '#FFF',
      marginTop: '20px',
    },
    tabsPaper: {
      paddingTop: t.spacing(2),
      paddingBottom: t.spacing(2),
      marginBottom: t.spacing(2),
      backgroundColor: `${storyColors[selectedTab]} !important`,
    },
    tab: {
      color: '#FFF',
    },
  }))();

  // v is the index value of tabs array
  function handleTabChange(e, v) {
    setSelectedTab(v);
    // // push story change to history
    // const pathParts = location.pathname.split('/');
    // if (stories.includes(pathParts[pathParts.length - 1])) {
    //   pathParts[pathParts.length - 1] = stories[v];
    // } else {
    //   // this was loaded without selected story
    //   pathParts.push(stories[v]);
    // }
    // history.push(pathParts.join('/'));
  }

  const tabIndicatorStyle = {
    backgroundColor: '#FFFFFF',
  };

  if (useMediaQuery(theme.breakpoints.down('xs'))) {
    tabIndicatorStyle.width = 10;
  }

  return (
    <>
      {/* <Box displayPrint="none"> */}
      <Paper square className={classes.stateHeader}>
        <Grid container className={classes.maxContentWidth}>
          <Grid item xs={6}>
            <Typography variant="h3" component="h1" className={classes.stateName}>{states[stateCode.toUpperCase()]}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" justifyContent="flex-end">
              <ResponsiveContainer width={80} aspect={1}>
                <StateMap color="#fff" stateCode={stateCode} />
              </ResponsiveContainer>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <Paper square className={classes.tabsPaper}>
        <Tabs
          orientation={useMediaQuery(theme.breakpoints.down('xs')) ? 'vertical' : 'horizontal'}
          value={selectedTab}
          variant={useMediaQuery(theme.breakpoints.down('xs')) ? 'fullWidth' : 'standard'}
          onChange={handleTabChange}
          TabIndicatorProps={{
            style: tabIndicatorStyle,
          }}
          className={classes.maxContentWidth}
        >
          <Tab className={classes.tab} label={`Affordability ${years.inReview}`} />
          <Tab className={classes.tab} label={`Access ${years.inReview}`} />
          <Tab className={classes.tab} label={`Lead exposure ${years.inReview}`} />
          <Tab className={classes.tab} label="COVID-19" style={{ display: stateCode.toLowerCase() === 'il' || stateCode.toLowerCase() === 'mn' ? 'none' : 'inherit' }} />
        </Tabs>
      </Paper>
      {/* </Box> */}

      <Container className={classes.maxContentWidth}>
        {selectedTab === 0 && <AffordabilityStory />}
        {selectedTab === 1 && <AccessStory />}
        {selectedTab === 2 && <LeadStory />}
        {selectedTab === 3 && <CovidStory />}
      </Container>
    </>
  );
}
